"use client";
// src/app/(auth)/signup/page.tsx - User signup page
// Signup page uses client hooks and requires SSR
export const dynamic = 'force-dynamic';

import { SignupForm } from '@/components/auth/AuthForm';
import { AuthPageLayout, SignupFooter } from '@/components/auth/shared';
import { useAuth } from '@/contexts/AuthContext';
import { memo, useCallback } from 'react';

interface SignupData {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
}

const SignupPage = memo(() => {
  const { isLoggingIn, loginError, signup } = useAuth();

  const handleSignup = useCallback(async (data: SignupData) => {
    try {
      await signup(data.firstName, data.lastName, data.email, data.password);
      // Signup successful - user will be automatically logged in and redirected
    } catch (error) {
      // Error will be handled by AuthContext and displayed via loginError
      console.error('Signup failed:', error);
    }
  }, [signup]);

  return (
    <AuthPageLayout
      title="Create Your Account"
      description="Join Courtly and start booking courts today!"
      footerContent={<SignupFooter />}
    >
      <SignupForm
        onSubmit={handleSignup}
        isLoading={isLoggingIn}
        error={loginError}
      />
    </AuthPageLayout>
  );
});

SignupPage.displayName = 'SignupPage';

export default SignupPage;
